import { Button, TextInput } from 'components/Form'
import { SimpleTable } from 'components/Ui'
import React, { useState } from 'react'
import { HiOutlineTrash } from 'react-icons/hi'

const resetData = {
    weight: '',
    unit: '',
    rate: '',
}

const WeightSlabs = ({ value, onChange }) => {
    const [slabsData, setSlabsData] = useState(
        value ? (Array.isArray(value) ? value : JSON.parse(value)) : [],
    )
    const [slab, setSlab] = useState(resetData)
    const [invalid, setInvalid] = useState(false)

    const handleChange = (e) => {
        const { name, value } = e.target
        setSlab((prevState) => ({
            ...prevState,
            [name]: value,
        }))
    }

    const checkValidation = (name) => {
        if (!name) {
            setInvalid(true)
            return !!(slab.weight && slab.unit && slab.rate)
        } else if (!slab[name]) {
            return true
        }
        return false
    }

    return (
        <div className="flex justify-between col-span-4">
            <div className="w-full mr-2">
                <div className="mb-2 font-bold">
                    <p>Add Slabs</p>
                </div>
                <div className="mb-4">
                    <TextInput
                        size="sm"
                        name="weight"
                        type="text"
                        placeholder="Weight (ex-1)"
                        invalid={invalid && checkValidation('weight')}
                        value={slab.weight}
                        onChange={handleChange}
                    />
                </div>
                <div className="mb-4">
                    <TextInput
                        size="sm"
                        name="unit"
                        type="text"
                        placeholder="Unit (ex-Kg)"
                        invalid={invalid && checkValidation('unit')}
                        value={slab.unit}
                        onChange={handleChange}
                    />
                </div>
                <div className="mb-4">
                    <TextInput
                        size="sm"
                        name="rate"
                        type="text"
                        placeholder="Rate (ex-10)"
                        invalid={invalid && checkValidation('rate')}
                        value={slab.rate}
                        onChange={handleChange}
                    />
                </div>
                <div className="pt-3 flex gap-2 text-right bg-white border-t border-gray-200 dark:bg-gray-800 dark:border-gray-700">
                    <Button
                        className="h-10 w-18 text-primary border border-primary dark:text-secondary dark:border-secondary"
                        type="button"
                        onClick={() => {
                            setSlab(resetData)
                            setInvalid(false)
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        className="flex items-center justify-center px-6 py-2 text-white transition border rounded-lg cursor-pointer hover:bg-opacity-90 border-primary bg-primary dark:border-secondary dark:bg-secondary"
                        type="button"
                        onClick={() => {
                            if (checkValidation()) {
                                let arr = [...slabsData]
                                arr.push(slab)
                                setSlabsData(arr)
                                setSlab(resetData)
                                setInvalid(false)
                                onChange(JSON.stringify(arr))
                            }
                        }}
                    >
                        Add
                    </Button>
                </div>
            </div>
            <div className="w-full ml-2">
                <div className="mb-2 font-bold">
                    <p>Slabs</p>
                </div>
                <div>
                    <SimpleTable compact>
                        <thead>
                            <SimpleTable.TR>
                                <SimpleTable.TH>
                                    <div className="text-center text-white">
                                        Slab
                                    </div>
                                </SimpleTable.TH>
                                <SimpleTable.TH>
                                    <div className="text-center text-white">
                                        Rate
                                    </div>
                                </SimpleTable.TH>
                                <SimpleTable.TH>
                                    <div className="text-center text-white">
                                        Action
                                    </div>
                                </SimpleTable.TH>
                            </SimpleTable.TR>
                        </thead>
                        <tbody>
                            {slabsData?.map((item, index) => (
                                <SimpleTable.TR
                                    key={index}
                                    className="text-center"
                                >
                                    <SimpleTable.TD>
                                        {item.weight} {item.unit}
                                    </SimpleTable.TD>
                                    <SimpleTable.TD>{item.rate}</SimpleTable.TD>
                                    <SimpleTable.TD>
                                        <div
                                            className="flex justify-center cursor-pointer hover:text-red-500"
                                            onClick={() => {
                                                let arr = [...slabsData]
                                                arr.splice(index, 1)
                                                setSlabsData(arr)
                                                onChange(
                                                    arr.length
                                                        ? JSON.stringify(arr)
                                                        : '',
                                                )
                                            }}
                                        >
                                            <HiOutlineTrash size="18px" />
                                        </div>
                                    </SimpleTable.TD>
                                </SimpleTable.TR>
                            ))}
                        </tbody>
                    </SimpleTable>
                </div>
            </div>
        </div>
    )
}

export default WeightSlabs
